module.exports = __webpack_public_path__ + "img/nature-40.de712c22.jpg";